"use client";

import { useState } from "react";
import { useRouter } from "@bprogress/next";
import { PencilIcon, Trash2Icon } from "lucide-react";

import { SuperLink as Link } from "@/components/common/super-link";
import { clientDel } from "@/service/client-api/client-api";
import { DeleteModal } from "@/components/common/delete-modal";

export const ReportManageActions = ({
  editHref,
  deleteEndpoint,
  reportId,
}: {
  editHref: string;
  deleteEndpoint: string;
  reportId: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const remove = async () => {
    setIsOpen(false);
    await clientDel(deleteEndpoint, { report: reportId });
    router.refresh();
  };

  return (
    <>
      <Link
        href={editHref}
        className={"flex items-center gap-2 hover:cursor-pointer"}
      >
        <PencilIcon size="16px" />
        Edytuj
      </Link>
      <div
        className={"flex items-center gap-2 hover:cursor-pointer"}
        onClick={() => setIsOpen(true)}
      >
        <Trash2Icon size="16px" />
        Usuń
      </div>

      <DeleteModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onDelete={remove}
        resourceName="opinię"
      />
    </>
  );
};
